import { BrowserRouter, Route, Routes } from "react-router-dom";
import Sorteio from "./pages/Sorteio";
import Bingo from "./pages/Bingo";
import Carrossel from "./pages/Carrossel";
import Home from "./pages/Home";

function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />}></Route>
                <Route path="/Sorteio" element={<Sorteio />}></Route>
                <Route path="/Bingo" element={<Bingo />}></Route>
                <Route path="/Carrossel" element={<Carrossel />}></Route>
            </Routes>
        </BrowserRouter>
    )
}

export default AppRoutes
